import { lpConfig } from "../lpConfig";

/**
 * ランディングページの企業ロゴトラストバンド
 * 利用企業のロゴプレースホルダーを横スクロールアニメーションで表示する
 * @return {JSX.Element} ロゴバンドコンポーネント
 */
export function LpLogoBand() {
  return (
    <section className="bg-gray-50 py-12 overflow-hidden">
      <p className="text-sm text-gray-400 uppercase tracking-widest mb-8 text-center">
        {lpConfig.logoBand.heading}
      </p>

      <div className="relative">
        <div className="lp-marquee flex">
          {/* First set */}
          {lpConfig.logoBand.companies.map(name => (
            <span
              key={`a-${name}`}
              className="px-8 text-2xl font-bold text-gray-300 whitespace-nowrap"
            >
              {name}
            </span>
          ))}

          {/* Duplicate set for seamless loop */}
          {lpConfig.logoBand.companies.map(name => (
            <span
              key={`b-${name}`}
              className="px-8 text-2xl font-bold text-gray-300 whitespace-nowrap"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
